export class Filtertag {
    tagId:string;
    title:string;
    tagtype:string;
    personId:string;
    creator?:string;
    created?:string;
    organizationId:string;
    organizationname:string;
}